import {_set} from '../objectz';

/**
 * Normally the subscribe function is executed immediately upon subscription, even though value has not changed
 * This skips that one and waits until a change fires it. https://stackoverflow.com/a/66819321
 * @param {*} store the store to subscribe
 * @param {*} fn the normal sub function
 * @returns the function to pass to unsubscribe
 */
export function subscribeWait(store, fn) {
  let firedFirst = false;
  return store.subscribe(state => {
      if (!firedFirst) {
          firedFirst = true;
      } else {
          fn(state);
      }
  })
}

/**
 * same as 'get' but wrapped in a promise. Subscribes once and then immediately invoke to unsubscribe
 */
export function subscribeOnce(observable) {
  return new Promise((resolve) => {
    observable.subscribe(resolve)(); // immediately invoke to unsubscribe
  });
}

/**
 * objectz/lodash property 'set' but for a store.
 * example: if store = writable({x:{y:1}})
 * then calling update(store, 'x.y', 2) will result in {x:{y:2}}
 */
export function updateValue(store, path, value) {
  store.update((o) => {
    _set(o, path, value);
    return o;
  });
}
